import Reveal from "@/components/base/Reveal";
import { checklist } from "@/mocks/home";

export default function Checklist() {
  return (
    <section id="checklist" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-[1.1fr_0.9fr]">
          <div>
            <Reveal>
              <p className="font-label text-xs font-semibold uppercase tracking-[0.25em] text-primary-600">
                Before Watching
              </p>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                观看前的五项检查
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                决定观看之前，把这几点确认一遍，通常能减少中途才发现版本不符、字幕错位之类的麻烦。
              </p>
            </Reveal>

            <ul className="mt-8 space-y-3">
              {checklist.map((item, index) => (
                <Reveal key={item.title} delay={index * 70}>
                  <li className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-accent-300">
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                      <i className={`${item.icon} text-lg`} aria-hidden="true"></i>
                    </span>
                    <span>
                      <span className="block font-heading text-sm font-bold text-foreground-950">{item.title}</span>
                      <span className="mt-1 block text-sm leading-relaxed text-foreground-600">{item.desc}</span>
                    </span>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>

          <Reveal delay={120}>
            <div className="overflow-hidden rounded-lg border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20indoor%20viewing%20scene%20with%20warm%20lamp%20light%2C%20soft%20crimson%20and%20amber%20tones%2C%20comfortable%20living%20room%20blurred%20in%20background%2C%20artistic%20cinematic%20rendering%2C%20calm%20evening%20mood&width=1000&height=1200&seq=shaozi-watch-01&orientation=portrait"
                alt="安静室内环境下观看作品的氛围示意图"
                className="h-[360px] w-full object-cover object-top md:h-[460px]"
              />
              <div className="border-t border-background-200 bg-secondary-100 px-5 py-4">
                <p className="flex items-center gap-2 text-sm font-medium text-secondary-900">
                  <i className="ri-headphone-line" aria-hidden="true"></i>
                  耳机或安静环境更利于分辨配音与对白细节
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}